import { sumBy } from 'lodash';
import { InvoiceGlBreakoutItem } from 'src/services/useInvoiceGlBreakoutApi';
import { round } from 'src/utils/number';

export const calculateTotals = (
  invoiceGlCodes: InvoiceGlBreakoutItem[]
): InvoiceGlBreakoutItem => ({
  glLabel: 'Totals:',
  notes: '',
  glSubTotal: round(
    sumBy(invoiceGlCodes, (item) => item.glSubTotal || 0),
    2
  ),
  taxableAmount: round(
    sumBy(invoiceGlCodes, (item) => item.taxableAmount || 0),
    2
  ),
  discountAmt: round(
    sumBy(invoiceGlCodes, (item) => Number(item.discountAmt || 0)),
    2
  ),
  shipCostAmt: round(
    sumBy(invoiceGlCodes, (item) => Number(item.shipCostAmt || 0)),
    2
  ),
  salesTaxAmt: round(
    sumBy(invoiceGlCodes, (item) => Number(item.salesTaxAmt || 0)),
    2
  ),
  glTotal: round(
    sumBy(invoiceGlCodes, (item) => item.glTotal || 0),
    2
  ),
  glCode: '',
  glCodeId: 0,
  rowId: 'noExpand',
  glBalance: 0,
  subTotalAmt: 0,
  taxableAmt: 0,
});
